export { fontWeights } from '../../dls';
